import React from 'react';
import './style/About.css';
import TopNavbar from './TopNavbar';

const About = () => {
  const features = [
    { icon: "📖", title: "Study Material", description: "NCERT-aligned theory, short note, formula, toper note, flashcards, mindmaps, diagrams & notes for complete concept clarity." },
    { icon: "☀️", title: "Practice (DPP)", description: "Daily Practice Problems to keep your preparation on track." },
    { icon: "🔁", title: "NEET Repeated Ques.", description: "Master the questions that appear most frequently in the exam." },
    { icon: "📅", title: "Previous Year Ques.", description: "Access a comprehensive archive of past NEET exam papers." },
    { icon: "🎲", title: "Practice Random Que.", description: "Test your knowledge with randomized questions across all topics." },
    { icon: "📋", title: "Mock Tests", description: "Full-length mock tests to simulate the real exam environment." },
    { icon: "📜", title: "Mock Test for PYQ", description: "Specialized tests designed around previous year question patterns." },
    { icon: "⭐", title: "Bookmarked Questions", description: "Save challenging questions to review and practice later." },
    { icon: "📑", title: "Bookmarked PDFs", description: "Quick access to your most important saved study materials." },
    { icon: "🕒", title: "Practice History", description: "Keep track of your previous sessions and review your mistakes." },
    { icon: "📊", title: "Study Progress", description: "Visual analytics to track your improvement over time." },
    { icon: "🗺️", title: "Syllabus", description: "Detailed breakdown of the latest NEET syllabus." },
    { icon: "⚖️", title: "Topic Wise Weightage", description: "Identify high-yield topics to prioritize your study time." }
  ];

  return (
    <div className="about-page">
      <TopNavbar name="About Us" />
      <br /><br /><br />

      {/* MANDATORY GOOGLE POLICY DISCLAIMER SECTION */}
      <div className="policy-disclaimer" style={{ backgroundColor: '#fff3cd', padding: '15px', margin: '10px', borderRadius: '8px', border: '1px solid #ffeeba' }}>
        <h4 style={{ color: '#856404', marginTop: 0 }}>⚠️ Important Disclaimer</h4>
        <p style={{ fontSize: '13px', color: '#856404', marginBottom: '10px' }}>
          <strong>NEET Prep</strong> is an independent educational platform. This app is <strong>NOT</strong> affiliated with, authorized by, or endorsed by the <strong>National Testing Agency (NTA)</strong> or any government organization.
        </p>
        <p style={{ fontSize: '13px', color: '#856404' }}>
          <strong>Source of Information:</strong> All exam patterns, syllabus details, and official notifications are sourced from the official NTA NEET website:
          <a href="https://nta.ac.in/" target="_blank" rel="noreferrer" style={{ marginLeft: '5px', fontWeight: 'bold' }}>
            https://nta.ac.in/
          </a>
        </p>
      </div>

      <div className="about-header">
        <h1>About NEET Prep</h1>
        <p>Your ultimate companion for cracking the NEET exam</p>
      </div>

      <div className="mission-section">
        <h2>Our Mission</h2>
        <div className="mission-content">
          <div className="mission-text">
            <p>
              At <strong>NEET Prep</strong>, our mission is to provide every medical aspirant
              with the most effective tools to <strong>qualify the NEET exam</strong> with confidence.
            </p>
            <p>
              We focus on precision, practice, and progress, ensuring that you have everything
              needed to turn your dream of becoming a doctor into reality.
            </p>
          </div>
          <div className="mission-stats">
            <div className="stat">
              <h3>100%</h3>
              <p>Student Focused</p>
            </div>
          </div>
        </div>
      </div>

      <div className="features-section">
        <h2>What We Provide</h2>
        <p className="section-subtitle">A complete toolkit for your NEET journey</p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* IN-APP PURCHASES & TRANSPARENCY SECTION */}
      <div className="why-us-section" style={{ marginTop: '20px' }}>
        <h2>In-App Purchases & Billing Transparency</h2>
        <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
          While core practice questions and syllabus breakdowns are available to explore, certain premium mock test series and advanced analytical reports require a digital subscription or one-time purchase.
        </p>
        <div className="benefits">
          <div className="benefit">
            <span className="benefit-icon">🔒</span>
            <div>
              <h4>Secure Payment via Google Play</h4>
              <p>All transactions and subscriptions are handled safely by Google Play Billing.</p>
            </div>
          </div>
          <div className="benefit">
            <span className="benefit-icon">⚡</span>
            <div>
              <h4>Instant Unlock</h4>
              <p>Purchased study packages and test series are activated immediately upon payment confirmation.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="why-us-section">
        <h2>Why Choose NEET Prep?</h2>
        <div className="benefits">
          <div className="benefit">
            <span className="benefit-icon">✅</span>
            <div>
              <h4>Structured Learning</h4>
              <p>Organized content from syllabus to topic weightage</p>
            </div>
          </div>
          <div className="benefit">
            <span className="benefit-icon">✅</span>
            <div>
              <h4>Performance Tracking</h4>
              <p>Monitor your progress with history and analytics</p>
            </div>
          </div>
          <div className="benefit">
            <span className="benefit-icon">✅</span>
            <div>
              <h4>Targeted Practice</h4>
              <p>Focus on repeated questions and mock tests</p>
            </div>
          </div>
          <div className="benefit">
            <span className="benefit-icon">✅</span>
            <div>
              <h4>Personalized Study</h4>
              <p>Bookmark questions and PDFs for custom revision</p>
            </div>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h2>Start Your Success Story</h2>
        <p>Join thousands of aspirants who are preparing smarter with NEET Prep</p>
      </div>
      <br /><br />
    </div>
  );
};

export default About;